<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="视频名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入视频名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="editVideoBtn('')" size="small" type="primary" class="bg-theme">添加视频</el-button>
      </div>
      <div class="text item">
        <el-table
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="categoryName"
            label="所属分类">
          </el-table-column>
          <el-table-column
            align="center"
            prop="videoName"
            label="视频名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="journeyBaseName"
            label="基地名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="添加时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-if="isJourneyUser == 1"
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
              <span v-if="isJourneyUser == 0">{{scope.row.status ? '开启' : '禁用'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editVideoBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button v-if="isJourneyUser == 1" @click="delVideoBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { querySeleniumJourneyVideoPageList, removeSeleniumJourneyVideoById, updateVideoStatusById } from '@/api/xyj'
export default {
  name: 'XyjVideo',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // isJourneyUser 是否属于基地账户 0-否 1-是
      isJourneyUser:1
    }
  },
  mounted () {
    var isJourneyUser = sessionStorage.getItem('isJourneyUser');
    this.isJourneyUser = isJourneyUser;
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      querySeleniumJourneyVideoPageList({ videoName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 视频-编辑 */
    editVideoBtn (infoId) {
      this.$router.push({path: '/xyj_video_add', query: {dataId: infoId}})
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      updateVideoStatusById({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 视频-删除 */
    delVideoBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeSeleniumJourneyVideoById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xyj/Video.vue